jQuery(document).ready(function($){

    $('input[type=checkbox]').on('change', function(){

        var branch = [];
        var vakgebied = [];
        var locatie = [];

        $('input[name="branch[]"]:checked').each(function(){
            branch.push($(this).val());
        });

        $('input[name="vakgebied[]"]:checked').each(function(){
            vakgebied.push($(this).val());
        });

        $('input[name="locatie[]"]:checked').each(function(){
            locatie.push($(this).val());
        });

        $.ajax({
            url: '/wp/wp-admin/admin-ajax.php',
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'filter_vacature',
                branch: branch,
                vakgebied: vakgebied,
                locatie: locatie
            },
            success: function(data){
                $(".vacancy").html(data.html);
            }
        });

    });

});